var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"corpo-pagina"},[_c('div',{staticClass:"row row-text"},[_c('div',{staticClass:"col s1"}),_c('div',{staticClass:"col s10 content-container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.translation('new_privacy'))}})]),_c('div',{staticClass:"col s1"})])]),_c('div',[(!_vm.isAuth)?_c('SignUpFree'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }